import React from 'react'
import { Container } from 'react-responsive-grid'
import '../css/markdown-styles'

import { rhythm } from '../utils/typography'

import '../css/slick-theme.css'
import '../css/slick.css'
import styled, { css } from 'styled-components'

import SocialBar from '../components/SocialBar'
import Header from '../components/Header'


import Carousel from '../components/Carousel'


module.exports = React.createClass({
  render () {
    const activeSquareColor = this.props.routes[this.props.routes.length - 1].page.data.color

    return (
      <div>
        <Header color={activeSquareColor} />
        <Container
          id='container'
          style={{
            maxWidth: 960,
            padding: `${rhythm(1)} ${rhythm(3/4)}`,
            paddingTop: 0,
          }}
        >
          <Carousel routes={this.props.routes} location={this.props.location} />
          {this.props.children}

          <SocialBar />

        </Container>
      </div>
    )
  },
})



// WEBPACK FOOTER //
// ./_template.jsx